import useWorldStore from '../store/worldStore';
import { saveMemory } from './agentMemory';
import { streamAgentMessage } from './openclawChat';

// TODO: Decide whether local clear chat should also call chatReset(), and
// whether reconnect should rehydrate from /v1/openclaw/chat/history.

export async function sendAgentMessage(agentId, userMessage) {
  const store = useWorldStore.getState();
  const agent = store.agents.find((a) => a.id === agentId);
  if (!agent) throw new Error('Agent not found');

  const chat = store.openChats.find((entry) => entry.agentId === agentId);
  const userMessageCount = (chat?.messages || []).filter((message) => message.role === 'user').length;

  store.setTyping(agentId, true);
  store.addMessage(agentId, {
    role: 'agent',
    text: '',
    ts: Date.now(),
    streaming: true,
  });

  try {
    const final = await streamAgentMessage(agentId, userMessage, {
      onChunk: (_chunk, acc) => store.appendToLastAgentMessage(agentId, acc),
    });

    if (final) {
      store.finalizeLastAgentMessage(agentId);
    } else {
      store.replaceLastAgentMessage(agentId, '...');
    }
    store.setTyping(agentId, false);

    if (userMessageCount % 3 === 0) {
      saveMemory(agentId, 'conversation', `Discussed: ${userMessage.slice(0, 60)}`, ['chat']);
    }

    return final || '...';
  } catch (error) {
    store.setTyping(agentId, false);
    store.replaceLastAgentMessage(agentId, `Error: ${error.message || String(error)}`);
    throw error;
  }
}
